import MapGroupMember from "../../../assets/svgs/person_white.svg";

export default {
  Id: 1,
  Name: "MassCommGroupMember",
  Discriminator: "MassComm",
  Icons: {
    Map: MapGroupMember,
  },
  LOCATION_TYPE: "LOCATION_TYPE",
  GROUP_TYPE: "GROUP_TYPE",
  GEOFENCED_MEMBERS_LAYER_ID: "geofencedGroupMembersLocations",
  GEOFENCE_LAYER_ID: "geofenceLocation",
  GROUP_MEMBER_LAYER_ID: "groupMembersLocations",
};
